import { render, staticRenderFns } from "./teamMemberTags.vue?vue&type=template&id=4652d5eb&scoped=true&"
import script from "./teamMemberTags.vue?vue&type=script&lang=js&"
export * from "./teamMemberTags.vue?vue&type=script&lang=js&"
import style0 from "./teamMemberTags.vue?vue&type=style&index=0&id=4652d5eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4652d5eb",
  null
  
)

export default component.exports